import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ColorData from "Components/CstmTheme/ColorData";
import ImgPath from "Constants/Imgs";

type SidebarDrawerProps = {
  open: boolean;
  onClose: () => void;
  navItems: {
    label: string;
    path: string;
    inactiveIcon: any;
    activeIcon: any;
  }[];
  handleLogout?: () => void;
};
// Optional: define animation duration if needed
const animationDuration = 200;

const SidebarDrawer: React.FC<SidebarDrawerProps> = ({
  open,
  onClose,
  navItems,
  handleLogout,
}) => {
  const [activeItem, setActiveItem] = useState("Dashboard");
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleItemClick = (label: string, path: string) => {
    if (label === "Logout") {
      handleLogout?.();
    } else {
      setActiveItem(label);
      onClose?.();

      // If it's an external path or .html page, do full redirect
      if (path?.endsWith(".html") || path?.startsWith("http")) {
        window.location.href = path;
      } else {
        navigate(path);
      }
    }
  };
  const DrawerList = (
    <Box
      sx={{
        width: 250,
        backgroundColor: ColorData.primary.main,
        height: "100%",
        px: 1.5,
        pt: 2,
      }}
      onClick={onClose}
    >
      <Box
        mb={5}
        display="flex"
        justifyContent="start"
        sx={{
          transition: `all ${animationDuration}ms ease-in-out`,
          overflow: "hidden",
        }}
      >
        <img
          src={"https://nolegalpaisa.com/assets/images/new_logo.webp"}
          alt="Logo"
          style={{
            objectFit: "contain",
            width: 200,
            height: 80,
            transition: `all ${animationDuration}ms ease-in-out`,
            cursor: "pointer",
            filter: "drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.3))",
          }}
          onClick={() => (window.location.href = "/home.html")}
        />
      </Box>
      <List>
        {navItems.map(({ label, inactiveIcon, activeIcon, path }, index) => {
          const isActive = label === activeItem;
          const isHovered = label === hoveredItem;
          return (
            <ListItem key={label} disablePadding>
              <ListItemButton
                onClick={() => handleItemClick(label, path)}
                onMouseEnter={() => setHoveredItem(label)}
                onMouseLeave={() => setHoveredItem(null)}
                sx={{
                  borderRadius: 2,
                  mb: 1.5,
                  px: 2,
                  py: 1.2,
                  minHeight: 48,
                  justifyContent: "flex-start",
                  bgcolor:
                    isActive || isHovered ? "#f0e8e4" : ColorData.primary.main,

                  "&:hover": {
                    bgcolor: "#f0e8e4",
                    color: ColorData.primary.main,
                  },
                  transition: `all ${animationDuration}ms ease-in-out`,
                }}
              >
                <ListItemIcon>
                  {isActive ? activeIcon : inactiveIcon}
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: "0.95rem",
                        fontWeight: 400,
                        color:
                          isActive || isHovered
                            ? ColorData.primary.main
                            : ColorData.text.secondary,
                        "&:hover": {
                          color: ColorData.primary.main,
                        },
                        opacity: 1,
                        transition: `opacity ${animationDuration}ms ease-in-out`,
                      }}
                    >
                      {label}
                    </Typography>
                  }
                />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Box>
  );

  return (
    <Drawer anchor="left" open={open} onClose={onClose}>
      {/* Drawer content goes here */}
      {DrawerList}
    </Drawer>
  );
};

export default SidebarDrawer;
